export default () => {
  return {
    userActionNotifications: [],
    userNonActionNotifications: [],
    userNotificationsCount: 0,
    userActionNotificationsCount: 0,
  };
};
